// Walking Pi — select_item tracking (GA4 has no native pixel event for "product clicked from a
// list"; Shopify Custom Pixels are DOM-sandboxed and can't see clicks, so this lives in theme JS,
// which has real DOM access. Shares the SAME client_id cookie the custom pixel writes
// (_wp_ga4_cid) so this event joins the same session as view_item_list/view_cart/add_shipping_info
// sent from the pixel — see reports/local/walkingpi/pixels/ga4-funnel-events-custom-pixel.js for
// why that cookie exists and its scope.
(function () {
  var MEASUREMENT_ID = 'G-ZCZ89395NX';
  var API_SECRET = 'YWLEre0QROa2uPboWi1nSQ';
  var COOKIE_NAME = '_wp_ga4_cid';

  function getCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('a[data-ga4-item-id]');
      if (!link) return;
      var listEl = link.closest('[data-ga4-list-id]');
      var clientId = getCookie(COOKIE_NAME);
      if (!clientId) return; // pixel hasn't set it yet (e.g. consent not granted) — skip, don't guess

      var payload = {
        client_id: clientId,
        events: [
          {
            name: 'select_item',
            params: {
              item_list_id: listEl ? listEl.getAttribute('data-ga4-list-id') : undefined,
              item_list_name: listEl ? listEl.getAttribute('data-ga4-list-name') : undefined,
              items: [
                {
                  item_id: link.getAttribute('data-ga4-item-id'),
                  item_name: link.getAttribute('data-ga4-item-name'),
                  price: Number(link.getAttribute('data-ga4-item-price')) || 0,
                },
              ],
            },
          },
        ],
      };

      navigator.sendBeacon
        ? navigator.sendBeacon(
            'https://www.google-analytics.com/mp/collect?measurement_id=' +
              MEASUREMENT_ID +
              '&api_secret=' +
              API_SECRET,
            JSON.stringify(payload)
          )
        : fetch(
            'https://www.google-analytics.com/mp/collect?measurement_id=' +
              MEASUREMENT_ID +
              '&api_secret=' +
              API_SECRET,
            { method: 'POST', body: JSON.stringify(payload), keepalive: true }
          ).catch(function () {});
    },
    true
  );
})();
